import { Button } from "components/Button/Button";
import { CheckableButton } from "components/CheckableButton/CheckableButton";
import { Position } from "components/Position/Position";
import { RangeSlider } from "components/RangeSlider/RangeSlider";
import { Textbox } from "components/Textbox/Textbox";
import { LayoutContext } from "layouts/DashboardLayout/context/LayoutContext";
import { useContext, useEffect, useState } from "react";
import { trans } from "utils/helpers";
import { getDeliverForm, getRate, sendDeliverForm } from "./api";
import { putCustomerFeedBack } from "../CustomerFeedBack/api";
import { OrganizationType } from "types/enum";
import { postReply } from "../MyOwnRequests/api";
import { Message } from "components/Message/Message";


interface props {
    mode?: any
    hide?: () => void
    onHide?: () => void
    reload?: () => void
    formCallBack?: (status) => void
    Id?:any
    jobId?:any
    taskId?:any
    referenceId?:any
    step?:any
    inDynamicForms?: any;
}

export const JobDeliveryForm = ({inDynamicForms=false ,step=1,referenceId,taskId,formCallBack, mode="create", onHide , hide,reload ,jobId , Id}:props) => {
  
    const [DeliveredTime, setDeliveredTime] = useState<any>();
    const [deliverForm, setDeliverForm] = useState<any>(null);
    const [rateRange, setRateRange] = useState<any>();
    const [resetForm, setResetForm] = useState<boolean>(false);
    const [saveAndSend, setSaveAndSend] = useState<any>(false);
    const [serviceRequest, setServiceRequest] = useState<any>(true);


    const layoutContext = useContext(LayoutContext);

    const handleSubmit = (event) => {
        event.preventDefault()
        if (mode == "edit") {
          let data:any
          if(step ==1){
           data  = {
            "TAS_UID" : taskId ,
            "JobId":jobId,
            "DeliveredTime": DeliveredTime,
            "ReceiverPerson":event.target.ReceiverPerson.value,
            "DeliveredByPositionId": event.target.DeliveredByPositionId.value,
            "Description": event.target.Description.value,
          }
          sendDeliverFormAsync(data, "post");
          }else if(step ==2){
            if (mode == "edit") {
              let IsDeliver = serviceRequest ;
              let CustomerFeedBackRate  = event.target.progressbar.value ;
              let CustomerFeedBackDescription = event.target.customerFeedBackDescription.value ;
              sendFeedBackDataAsync(jobId,IsDeliver,CustomerFeedBackRate,CustomerFeedBackDescription)
             //notWork
    
              } else {
                let IsDeliver = serviceRequest ;
                let CustomerFeedBackRate  = event.target.progressbar.value ;
                let CustomerFeedBackDescription = event.target.customerFeedBackDescription.value ;
                sendFeedBackDataAsync(jobId,IsDeliver,CustomerFeedBackRate,CustomerFeedBackDescription)
            }
          }
         //notWork

          } else {
            let data:any
            data  = {
              "TAS_UID" : taskId ,
              "JobId":jobId,
              "DeliveredTime": DeliveredTime,
              "ReceiverPerson":event.target.ReceiverPerson.value,
              "DeliveredByPositionId": event.target.DeliveredByPositionId.value,
              "Description": event.target.Description.value,
            }
            sendDeliverFormAsync(data, "post");
        }
    }
    async function sendFeedBackDataAsync(Id,IsDeliver,CustomerFeedBackRate,CustomerFeedBackDescription) {
        try {

          let res = await putCustomerFeedBack(Id,IsDeliver,CustomerFeedBackRate,CustomerFeedBackDescription );
           if(saveAndSend){
              // await postReply(CustomerFeedBackDescription ,referenceId);
               onHide && onHide();
          }
          hide && hide();
          reload && reload()
        }catch (err: any) {


         }
      }
    async function sendDeliverFormAsync(data, method) {
        try {
          let res = await sendDeliverForm(data ,method , referenceId );
          hide && hide();
          reload && reload()
          formCallBack&&formCallBack(true)
        } catch (err: any) {


        }
      }

    async function getDeliverFormAsync() {
        try {
          const res = await getDeliverForm(jobId ,referenceId  );
          setDeliveredTime(res.Data.DeliveredTime)
          setDeliverForm(res.Data)
          setServiceRequest(res.Data.deliverForm?.IsDeliver==null?true:res.Data.deliverForm?.IsDeliver)
          if(res?.Data.CustomerFeedBackDescription!=	null){
            formCallBack&&formCallBack(true)
          }else{ 
            formCallBack&&formCallBack(false)
          }
        } catch (err: any) {
     

         }

       // formCallBack&&formCallBack(true)
      }
    async function getRateAsync() {
        try {
          const res = await getRate();
          setRateRange(res?.Data)

          
        } catch (err: any) {


        }
      }

      useEffect(() => {
   
        getRateAsync();
        if (jobId){
          getDeliverFormAsync();
        } 
      }, [jobId]);
      useEffect(() => {
   
        formCallBack&&formCallBack(false)
      }, []);





    return (
     <form onSubmit={handleSubmit}>
       <div className="m-2">            
             
          <div className={` card mb-3 `}>
               <>

              {step > 1 && 
                    <div style={{ backgroundColor: "#cfe2ff", paddingRight: "20px" }} className="py-1 col-12 pr-4"> {trans("step")}-1</div>
                }
             <div className="card-body" >
             <div className="row">
              <div className="col-12 col-sm-4 mb-2 mb-sm-0">
                    <Position
                       name="DeliveredByPositionId"
                       label="DeliveredByPosition"
                       mode={"view"}
                       value={ layoutContext.currentUserPosition.PositionId }
                       resetForm={resetForm}

                   />
              </div>
              <div className="col-12 col-sm-4 mb-2 mb-sm-0">
                  <Textbox
                      textboxType="text"
                      textboxName="ReceiverPerson"
                      labelText="ReceiverPerson"
                      resetForm={resetForm}
                      defaultValue={deliverForm?.ReceiverPerson}
                      mode={step > 1 ? "view" : mode}

                  />
              </div>
              <div className="col-10 col-sm-10">
                        <Textbox
                            textboxType="textarea"
                            textboxName="Description"
                            labelText="Description"
                            mode={step > 1 ? "view" : mode}
                            resetForm={resetForm}
                            defaultValue={deliverForm?.Description}
                        />
               </div>
             </div>
            </div>   
              </>
          </div>


              {step >1 &&
              
              <div className="card">
                <div style={{ backgroundColor: "#cfe2ff", paddingRight: "20px" }} className="py-1 col-12 pr-4"> {trans("step")}-2 : (تایید و ارزیابی مشتری)</div>
                <div className="card-body">
                                      <Message message={trans("Msg_RateOurServices")} type={"info"} />
                  
                <div className="row">
              
                <div className="col-2 mt-4">
                    <CheckableButton
                      onchange={(e) =>
                        e && setServiceRequest(true)
                      }
                      defaultChecked={serviceRequest == true?true:false}
                      labelText={"ok"}
                      inputName={"confirm"}
                      type="radio"
                    />
                  </div>  
                  <div className="col-2 mt-4 ">
                                      <CheckableButton
                                         onchange={(e) =>
                                          e && setServiceRequest(false)
                                        }
                                        defaultChecked={serviceRequest == false?true:false}
                                        labelText={"decline"}
                                        inputName={"confirm"}
                                        type="radio"
                                      />
                                    </div>           
                                 
               
                  <div className="col mt-3 pb-4 pr-0">
                    <RangeSlider Range={rateRange} required={true} type={"icon"} mode={mode} label="Satisfaction" defaultValue={deliverForm?.CustomerFeedBackRate?deliverForm?.CustomerFeedBackRate:null	} name="progressbar" resetForm={resetForm} />
                  </div>
                  </div>
                 <div className="row">
                    <div className="col-10 col-sm-10">
                        <Textbox
                            textboxType="textarea"
                            textboxName="customerFeedBackDescription"
                            labelText="Description"
                            autoFocus={true}
                            required={!serviceRequest}
                            mode={mode}
                            resetForm={resetForm}
                            defaultValue={deliverForm?.CustomerFeedBackDescription	}
                        />
                    </div>
                 </div>
                </div>
              </div>
              }
             </div>
             <div className="row">
                 {mode != "view" ? (
                     <div className="d-flex justify-content-end">
                         
                          {(layoutContext.currentUserPosition.OrganizationType == OrganizationType.Customers)?
                          <Button value="SaveAndSend" btnType="submit" onClick={()=>{setSaveAndSend(true)}} />
                         :<Button btnType="submit" value="save" />
                          }
                         <Button
                             btnType="cancel"
                             value="cancel"
                             onClick={() => {hide && hide()}}
                         />
                     </div>
                     ) : (<></>)
                 }
             </div>
            </form>
    )
}